import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getSelectedTaskListIdFilterSelector } from "~/store/selectors/selector.configOptions";
import { getTaskListsByProjectId } from "~/store/selectors/selector.taskLists";
import { getTaskCountersCollectionSelector } from "~/store/selectors/selector.tasks";

export const useTaskListsFilterData = (projectId) => {
  const selected = useSelector((state) => getSelectedTaskListIdFilterSelector(state, projectId));

  const rawTaskLists = useSelector((state) => getTaskListsByProjectId(state, projectId));
  const counter = useSelector(getTaskCountersCollectionSelector);

  const filterSelected = useMemo(() => {
    return selected.filter((id) => {
      return !!rawTaskLists.get(`${id}`);
    });
  }, [selected, rawTaskLists]);

  const options = useMemo(() => {
    return rawTaskLists
      .toArray()
      .sort((taskList1, taskList2) => taskList1.get(`position`) - taskList2.get(`position`))
      .map((taskList) => {
        const id = taskList.get("id");
        const { open = 0, total = 0 } = counter[id] || {};
        return {
          id: id,
          name: `${taskList.get("name")}`,
          additionalInfo: `(${open}/${total})`,
        };
      });
  }, [counter, rawTaskLists]);

  return [filterSelected, options];
};
